import { createContext, useContext, useState } from "react";

// Create context
export const NavigationContext = createContext(null);

export const NavigationProvider = ({ children }) => {

  const [navigation_state] = useState({
    appSidebarOpen: false,
    showAppBottomSidebar: false,
    showFullPage: null
  });

  return (
    <NavigationContext.Provider value={{
      navigation_state,
    }}>
      {children}
    </NavigationContext.Provider>
  );
};

// Custom hook to use the navigation context
export const useNavigation = () => {
  return useContext(NavigationContext);
};

